/**
 * 防抖函数，在函数被触发后，在规定时间内如果函数没有被再次触发，则执行，如果被触发，则等待下次规定时间再执行。
 * @param {Function} fn 实际执行的函数
 * @param {Number} time 在规定时间内如果函数没有被再次触发，则执行，如果被触发，则等待下次规定时间再执行，默认时间我300毫秒
 * @returns {Function} 返回一个function，实际调用的是这个function。
 */
export default function debounce(fn, time = 300) {
    let timer = null;

    // 这里不用箭头函数的原因是为了能够使用调用这个函数的对象的this上下文
    return function debounceHandler(...args) {
        if (timer != null) {
            clearTimeout(timer);
        }
        timer = setTimeout(() => {
            // 这里不用 fn(...args)的原因还是为了保证this，因为 fn(...args) 会被编译成 fn.apply(undefined, args);
            fn.apply(this, args);
            timer = null;
        }, time);
    };
}
